export default __webpack_public_path__ + "assets/Sutter-TKO-line-white.80f6eff8.png";